import { render } from "./SloganTempate.vue?vue&type=template&id=73c2144a&scoped=true"
import script from "./SloganTempate.vue?vue&type=script&lang=js"
export * from "./SloganTempate.vue?vue&type=script&lang=js"

import "./SloganTempate.vue?vue&type=style&index=0&id=73c2144a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73c2144a"]])

export default __exports__